import { FormMode } from "@/consts/form";
import { StockItemsState } from "../types/state";
import { ActionContext } from "vuex";
import axiosAuth from "@/config/axios";
import { DefaultResponse } from "@/types/response";
import { endPoints } from "@/config/api";
import { useNotification } from "@/composables/useNotification";
import { StockItem } from "../types/stock_items";
import { IRootState } from "@/types/state";

const { notifySuccess, notifyError } = useNotification();

const defaultStockItem: StockItem = {
    description: '',
    unit: 'UN',
    stockTypeId: null,
    createdAt: new Date(),
    createdBy: '',
    updatedAt: null,
    updatedBy: null
};

const state: () => StockItemsState = () => ({
    filterStockItem: {
        description: '',
        baseValue: '',
        stockTypeId: null
    },
    stock_items: [],
    pagination: {
        page: 1,
        itemsPerPage: 10,
        total: 0
    },
    selectedStockItem: Object.assign({}, defaultStockItem),
    formMode: FormMode.ADD,
    showFormDialog: false,
    showDeleteDialog: false,
    showFilterDialog: false,
});

const mutations = {
    RESET_STOCK_ITEM_FILTER(state: StockItemsState) {
        state.filterStockItem = Object.assign({}, {description: '', baseValue: '', stockTypeId: null});
    },
    SHOW_DELETE_DIALOG(state: StockItemsState, payload: { show: boolean }) {
        state.showDeleteDialog = payload.show;
    },
    SHOW_FILTER_DIALOG(state: StockItemsState, payload: { show: boolean }) {
        state.showFilterDialog = payload.show;
    },
    SET_STOCK_ITEMS(state: StockItemsState, payload: { stock_items: StockItem[] }) {
        state.stock_items = payload.stock_items;
    },
    SHOW_FORM_DIALOG(state: StockItemsState, payload: { show: boolean }) {
        state.showFormDialog = payload.show;
    },
    SET_SELECTED_SERVICE(state: StockItemsState, payload: { stock_items: StockItem }) {
        state.selectedStockItem = Object.assign({}, payload.stock_items);
    },
    SET_FORM_MODE(state: StockItemsState, payload: { mode: FormMode }) {
        state.formMode = payload.mode;
    },
    SET_TOTAL(state: StockItemsState, payload: { total: number }) {
        state.pagination.total = payload.total;
    },
};
 
const actions = {
    openCreateDialog({ commit }: ActionContext<StockItemsState, IRootState>) {
        commit('SET_FORM_MODE', { mode: FormMode.ADD });
        commit('SET_SELECTED_SERVICE', { stock_items: defaultStockItem });
        commit('SHOW_FORM_DIALOG', { show: true });
      },
    openEditDialog({ commit }: ActionContext<StockItemsState, IRootState>, payload: { stock_items: StockItem }) {
        commit('SET_FORM_MODE', { mode: FormMode.EDIT });
        commit('SET_SELECTED_SERVICE', payload);
        commit('SHOW_FORM_DIALOG', { show: true });
    },
    openViewDialog({ commit }: ActionContext<StockItemsState, IRootState>,  payload: { stock_items: StockItem }) {
        commit('SET_FORM_MODE', { mode: FormMode.VIEW });
        commit('SET_SELECTED_SERVICE', payload);
        commit('SHOW_FORM_DIALOG', { show: true });
    },
    openDeleteDialog({ commit }: ActionContext<StockItemsState, IRootState>, payload: { stock_items: StockItem }) {
        commit('SHOW_DELETE_DIALOG', { show: true });
        commit('SET_SELECTED_SERVICE', { stock_items: payload.stock_items });
    },
    closeDialog({ commit }: ActionContext<StockItemsState, IRootState>) {
        commit('SHOW_FORM_DIALOG', { show: false });
    },
    async fetchStockItems({ commit, state }: ActionContext<StockItemsState, IRootState>, ) {
        try {
            const params: any = {};
        
            if (state.filterStockItem.description) {
                params.description = state.filterStockItem.description;
            }

            if (state.filterStockItem.baseValue) {
                params.baseValue = state.filterStockItem.baseValue;
            }
            if(state.filterStockItem.stockTypeId) {
                params.stockTypeId = state.filterStockItem.stockTypeId;
            }
            params.page = state.pagination.page;
            params.itemsPerPage = state.pagination.itemsPerPage;
            
            const response = await axiosAuth.get<DefaultResponse<StockItem>>(`${endPoints.stock_items}`, { params });
            commit('SHOW_FILTER_DIALOG', { show: false });
            commit('SET_STOCK_ITEMS', { stock_items: response.data.data });
            commit('SET_TOTAL', { total: response.data.total });
        } catch (error) {
            notifyError('Erro ao buscar itens do estoque');
        }
    },
    async createStockItem({ commit, dispatch, state }: ActionContext<StockItemsState, IRootState>) {
        try {
          await axiosAuth.post(`${endPoints.stock_items}`, state.selectedStockItem);
          notifySuccess('Item do estoque criado com sucesso');
          commit('SHOW_FORM_DIALOG', { show: false });
          dispatch('fetchStockItems');
        } catch (error) {
          notifyError('Erro ao criar item do estoque');
        }
    },
    async updateStockItem({ commit, dispatch, state }: ActionContext<StockItemsState, IRootState>) {
        const { id } = state.selectedStockItem;
        try {
          await axiosAuth.put(`${endPoints.stock_items}/${id}`, state.selectedStockItem);
          notifySuccess('Item do estoque atualizado com sucesso');
          commit('SHOW_FORM_DIALOG', { show: false });
          dispatch('fetchStockItems');
        } catch (error) {
          notifyError('Erro');
          console.error('Erro ao atualizar item do estoque:', error);
        }
    },
    async deleteStockItem({ commit, dispatch }: ActionContext<StockItemsState, IRootState>, payload: {stock_items: StockItem}) {
        try {
          await axiosAuth.delete(`${endPoints.stock_items}/${payload.stock_items.id}`);
          notifySuccess('Item do estoque deletado com sucesso');
          commit('SHOW_DELETE_DIALOG', { show: false });
          dispatch('fetchStockItems');
        } catch (error) {
          notifyError('Erro');
          console.error('Erro ao deletar item do estoque:', error);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};